import { BlocksIconManual } from 'blocks-nextjs/blocks-web-components/components/icon/icons/manual';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconManual = createComponent({ react: React, tagName: 'cat-icon-manual', elementClass: BlocksIconManual });
